import { Stack, Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { Tooltip } from 'framework/ui/mui-builder';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const DetailField = ({
  icon,
  value,
  tooltip,
  sx,
}: {
  icon: React.ReactNode;
  value: React.ReactNode;
  tooltip?: string;
  sx?: SxProps<Theme>;
}) => (
  <Stack direction="row" alignItems="center" spacing={1} minWidth={0} sx={sx}>
    <Tooltip title={tooltip}>
      <Box
        role={tooltip ? 'img' : undefined}
        aria-label={tooltip}
        tabIndex={tooltip ? 0 : undefined}
        sx={{ display: 'flex', color: 'text.secondary' }}
      >
        {icon}
      </Box>
    </Tooltip>
    <Typography sx={{ minWidth: 0, width: '100%' }}>{value || EMPTY_VALUE_INDICATOR}</Typography>
  </Stack>
);

export default DetailField;
